// helpers
import {formatCurrency} from '../../../../helpers';

// types
import {TFunction} from 'i18next';
import {LoanDetails} from '../../../../services/ApiService/types';

/**
 * Get the detailed fields for loan details
 * @param loanDetails
 * @param t
 */
export const getDetailedFields = (loanDetails: LoanDetails, t: TFunction) => {
  const fields = [
    {
      label: t('global_status'),
      content: loanDetails.status,
    },
    {
      label: t('loan_loanAmount'),
      content: formatCurrency(loanDetails.loanAmount),
    },
    {
      label: t('global_currentBalance'),
      content: formatCurrency(loanDetails.currentBalance),
    },
    {
      label: t('global_paymentFrequency'),
      content: loanDetails.paymentFrequency,
    },
    {
      label: t('global_numberOfPayments'),
      content: loanDetails.initialNumberOfPayments.toString(),
    },
    {
      label: t('global_initialPaymentAmount'),
      content: formatCurrency(loanDetails.initialPaymentAmount),
    },
    {
      label: t('global_totalOwing'),
      content: formatCurrency(loanDetails.totalOwing),
    },
    {
      label: t('global_creationDate'),
      content: loanDetails.creationDate,
    },
  ];
  return fields;
};
